<template>
  <div class="expert">
    <!-- 手机端内容 -->
    <div class="mobile_expert_page">
      <img width="100%" src="../assets/img/mobile/expert.jpg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'expert',
  data () {
    return {}
  },
  mounted () {
    document.querySelector('.mobile_expert_page').style.height =
      window.innerHeight + 'px'
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1170px) {
  .pc_expert_page {
    display: none;
  }
  .mobile_expert_page {
    display: block;
    background: #0357d3;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/expert.vue